// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3FPv_","inputs":"styles_inputs__2AfNX"};